import { createContext } from 'react'

import { DefaultEventsMap } from '@socket.io/component-emitter'
import { Socket } from 'socket.io-client'

export const WebSocketContext = createContext<
  Socket<DefaultEventsMap, DefaultEventsMap> | undefined
>(undefined)